<form [formGroup]="formData" novalidate (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ pageTitle }}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="">Product / SKU: </label>

      <ng-select
        [items]="rfq$ | async"
        bindLabel="internal_sku"
        [addTag]="false"
        [multiple]="false"
        [hideSelected]="true"
        [trackByFn]="trackByFn"
        [loading]="rfqLoading"
        [typeahead]="rfqInput$"
        formControlName="rfq"
        (change)="setRfq()"
      >
        <ng-template ng-label-tmp let-item="item">
          [{{ item.internal_sku }}] {{ item.product_name }}
        </ng-template>

        <ng-template
          ng-option-tmp
          let-item="item"
          let-index="index"
          let-search="searchTerm"
        >
          [{{ item.internal_sku }}] {{ item.product_name }}
        </ng-template>
      </ng-select>
    </div>

    <div class="form-group">
      <label for="">Select location transfer type: </label><br />
      <mat-radio-group
        aria-label="Select an option"
        name="transfer_type"
        formControlName="transfer_type"
        required
      >
        <mat-radio-button value="1"
          >Import / Partial Location Transfer</mat-radio-button
        >
        <mat-radio-button value="2">Full Transfer</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="form-group" *ngIf="formData.value.transfer_type == 2">
      <label for="">Move/transfer locations from: </label><br />
      <div formArrayName="previous_locations">
        <mat-checkbox
          *ngFor="
            let ctrl of formData.controls['previous_locations'].controls;
            let i = index
          "
          [formControl]="ctrl"
          class="mr-3"
        >
          {{ formData.value.rfq.locations[i].location_name }}
        </mat-checkbox>
      </div>
    </div>

    <div class="form-group">
      <label for="">Move/transfer locations to: </label>
      <ng-select
        [items]="warehouses"
        groupBy="locations"
        bindLabel="location_name"
        formControlName="locations"
        [multiple]="true"
      >
        <ng-template ng-optgroup-tmp let-item="item">
          {{ item.location_name }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ item.location_name }}
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="modal-footer">
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="loading"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
    >
      Confirm SKU location
    </button>
  </div>
</form>
